import { getCurrentSession } from '../../lib/authentication';

export const fetch = (params = {}) => {
  return Promise.all([getCurrentSession()])
    .then(results => {
      const [session] = results;

      const { accessToken } = session;
      return apigClient
        .adminInvitesGet(params, {}, {
            headers: {
                Authorization: accessToken
            }
        })
        .then(resp => resp.data)
        .catch(e => {
            throw e.data;
        });
    });
};


export const create = (params = {}) => {
  return Promise.all([getCurrentSession()])
    .then(results => {
      const [session] = results;

      const { accessToken } = session;
      return apigClient
        .adminInvitesCreate(params, {}, {
            headers: {
                Authorization: accessToken
            }
        })
        .then(resp => resp.data)
        .catch(e => {
            throw e.data;
        });
    });
};

export const remove = (params = {}) => {
  return Promise.all([getCurrentSession()])
    .then(results => {
      const [session] = results;

      const { accessToken } = session;
      return apigClient
        .adminInvitesRemove(params, {}, {
            headers: {
                Authorization: accessToken
            }
        })
        .then(resp => resp.data)
        .catch(e => {
            throw e.data;
        });
    });
};
